/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import './Landing.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import successBillPic from '../../assets/pictures/willSuccess.gif'
import failedBillPic from '../../assets/pictures/willFailed.gif'
import { get, post } from '../../services/https'
import { ToRial } from '../../services/money'

import { useNavigate } from 'react-router-dom'

export default function Success() {
  const navigate = useNavigate()

  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)
  const Authority = params.get("Authority")

  const [order, setOrder] = useState([])
  const [basket, setBasket] = useState([])
  const [statusPage, setStatusPage] = useState(false)

  useEffect(() => {
    get(`/api/front/order/${Authority}`)
      .then(response => {
        post(`/api/front/payment/verify/`, {
          authority: Authority,
          amount: response.data.data.total
        })
          .then(responseVerify => {
            setOrder(responseVerify.data.data)
            setBasket(responseVerify.data.data.basket)
            setStatusPage(true)
          })
          .catch(error => {
            notify('error', 'خطا در ارسال اطلاعات')
            setStatusPage(true)
          })
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [])

  return (
    <div id='SignUp'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <div className="bill" style={statusPage ? { filter: 'blur(0px)' } : { filter: 'blur(5px)' }}>
          <img src={order.payStatus ? successBillPic : failedBillPic} alt="" />
          <div className={order.payStatus ? 'success' : 'faild'}>
            {order.payStatus ? 'خرید با موفقیت انجام شد' : 'خرید ناموفق بود'}
          </div>
          {order ? (
            <div className='refId'>کد پرداخت : {order.refId}</div>
          ) : ''}
          {basket ? (
            <div className='orderNumber'>شماره سفارش : {order.orderNumber}</div>
          ) : ''}
          {basket ? (
            <ul className='orderNumber'>
              {basket.map(item => (
                <li key={item._id}>
                  <span>{item.name}</span>
                  <span>تعداد : {item.count}</span>
                </li>
              ))}
            </ul>
          ) : ''}
          {order ? (
            <div className='orderNumber'>جمع کل : {ToRial(String(order.total))} تومان</div>
          ) : ''}
          <hr />
          <div className='problem'>می توانید تاریخچه سفارشات خود را با رفتن به بخش سفارشات خود مشاهده کنید</div>
          <div className='problem'>همچنین در صورت وجود هرگونه مشکل می توانید با پشتیبانی در تماس باشید</div>
        </div>
        <div className="bilButtonCountainer">
          <button onClick={() => navigate('/')}>بازگشت به منو</button>
        </div>
      </div>
      <Footer page={''} />
    </div>
  )
}
